'use strict';

module.exports = require('./time-picker');


/*****************
 ** WEBPACK FOOTER
 ** ./~/material-ui/lib/time-picker/index.js
 ** module id = 325
 ** module chunks = 0
 **/